import React, { useState } from 'react';
import '../styles/CatalogForm.css';

export const CATEGORIAS = [
  'Casa e Decoração',
  'Construção e Ferramentas',
  'Vestuário',
  'Sapatos e Acessórios',
  'Informática e Eletrônicos',
  'Empresas',
  'Automotivos',
  'Esportes',
  'Pet',
  'Beleza e Saúde',
  'Brinquedos',
];

const KEYWORDS_CAT = {
  'Casa e Decoração': ['globo', 'vaso', 'decor', 'tapete', 'cortina', 'luminar', 'espelho', 'quadro', 'almofada', 'cama', 'mesa', 'sofa', 'sofá', 'rack', 'prateleira', 'pendente', 'abajur', 'enfeite', 'natal', 'jardim', 'iluminac', 'cozinha', 'panela', 'lencol', 'toalha', 'copo', 'prato', 'xicara'],
  'Construção e Ferramentas': ['furadeira', 'parafusadeira', 'martelo', 'alicate', 'serra', 'ferrament', 'construc', 'tinta', 'eletric', 'tomada', 'parafuso', 'prego', 'trena', 'nivel'],
  'Vestuário': ['camisa', 'camiseta', 'calca', 'calça', 'vestido', 'blusa', 'jaqueta', 'casaco', 'roupa', 'bermuda', 'short', 'saia', 'moletom', 'pijama', 'meia', 'termica', 'térmica', 'uniforme', 'regata'],
  'Sapatos e Acessórios': ['sapato', 'tenis', 'tênis', 'sandalia', 'sandália', 'chinelo', 'bota', 'bolsa', 'mochila', 'carteira', 'cinto', 'oculos', 'óculos', 'relogio', 'relógio', 'bijuteria', 'colar', 'pulseira', 'brinco', 'chapeu', 'chapéu', 'bone', 'boné', 'anel'],
  'Informática e Eletrônicos': ['computador', 'notebook', 'tablet', 'celular', 'smartphone', 'fone', 'headphone', 'teclado', 'mouse', 'monitor', 'impressora', 'cabo', 'carregador', 'bateria', 'televisao', 'televisão', 'caixa de som', 'camera', 'câmera', 'eletron', 'usb', 'hdmi', 'bluetooth', 'roteador', 'tv '],
  'Empresas': ['escritorio', 'escritório', 'corporativo', 'empresa', 'comercial', 'industrial'],
  'Automotivos': ['carro', 'automotiv', 'veicular', 'pneu', 'volante', 'limpador de para'],
  'Esportes': ['bicicleta', 'haltere', 'esteira', 'yoga', 'futebol', 'basquete', 'natacao', 'natação', 'academia', 'esport', 'fitness', 'musculacao', 'musculação'],
  'Pet': ['pet', 'cachorro', 'gato', 'aquario', 'aquário', 'gaiola', 'coleira', 'racao', 'ração'],
  'Beleza e Saúde': ['perfume', 'creme', 'shampoo', 'condicionador', 'maquiagem', 'skincare', 'vitamina', 'suplemento', 'barbear', 'secador', 'chapinha', 'hidratante', 'beleza', 'saude', 'saúde'],
  'Brinquedos': ['brinquedo', 'boneca', 'carrinho de brinc', 'lego', 'quebra-cabeca', 'quebra-cabeça', 'jogo de tabuleiro', 'pelucia', 'pelúcia', 'action figure', 'nerf', 'hot wheels', 'barbie', 'playmobil', 'massinha'],
};

export function detectarCategorias(titulo) {
  const t = titulo.toLowerCase();
  return CATEGORIAS.filter(cat => (KEYWORDS_CAT[cat] || []).some(kw => t.includes(kw)));
}

const EMPTY_FORM = {
  linkProduto: '',
  titulo: '',
  precoWeb: '',
  meuPreco: '',
  quantidade: '',
  altura: '',
  largura: '',
  comprimento: '',
  peso: '',
  descricao: '',
  imagens: [],
  categorias: [],
  subcategorias: [],
};

// Extrai o ID de produto do Mercado Livre de uma URL
function parseMlId(url) {
  const match = url.match(/MLB[-]?(\d+)/i);
  return match ? 'MLB' + match[1] : null;
}

// Extrai uma meta tag OG de HTML bruto
function getOgTag(html, property) {
  const re1 = new RegExp(`<meta[^>]+property=["']og:${property}["'][^>]+content=["']([^"']+)["']`, 'i');
  const re2 = new RegExp(`<meta[^>]+content=["']([^"']+)["'][^>]+property=["']og:${property}["']`, 'i');
  const m = html.match(re1) || html.match(re2);
  return m ? m[1] : '';
}

// Busca atributo ML pelo ID (ex: 'HEIGHT', 'WEIGHT')
function getMlAttr(attributes, ...ids) {
  for (const id of ids) {
    const found = (attributes || []).find(a => a.id === id);
    if (found && found.value_name) return found.value_name;
  }
  return '';
}

// Converte string de dimensão para cm (ex: "80 mm" → "8", "0.5 m" → "50")
function parseCm(str) {
  if (!str) return '';
  const m = str.match(/([\d.,]+)\s*(mm|cm|m)\b/i);
  if (!m) return '';
  const val = parseFloat(m[1].replace(',', '.'));
  const unit = m[2].toLowerCase();
  if (unit === 'mm') return String(parseFloat((val / 10).toFixed(1)));
  if (unit === 'm')  return String(val * 100);
  return String(val); // já em cm
}

// Converte string de peso para gramas (ex: "0.5 kg" → "500", "100 g" → "100")
function parseGramas(str) {
  if (!str) return '';
  const m = str.match(/([\d.,]+)\s*(mg|g|kg)\b/i);
  if (!m) return '';
  const val = parseFloat(m[1].replace(',', '.'));
  const unit = m[2].toLowerCase();
  if (unit === 'kg') return String(Math.round(val * 1000));
  if (unit === 'mg') return String(Math.round(val / 1000));
  return String(Math.round(val)); // já em g
}

function buildInitial(editProduct) {
  if (!editProduct) return EMPTY_FORM;
  return {
    ...EMPTY_FORM,
    ...editProduct,
    imagens: editProduct.imagens && editProduct.imagens.length
      ? editProduct.imagens
      : (editProduct.imagem ? [editProduct.imagem] : []),
    linkProduto: editProduct.linkProduto || '',
    quantidade: editProduct.quantidade || '',
    categorias: editProduct.categorias || [],
    subcategorias: editProduct.subcategorias || [],
  };
}

function CatalogForm({ onAddProduct, editProduct }) {
  const [formData, setFormData] = useState(() => buildInitial(editProduct));
  const [dragIdx, setDragIdx] = useState(null);
  const [uploadandoCount, setUploadandoCount] = useState(0);
  const [buscandoLink, setBuscandoLink] = useState(false);
  const [linkStatus, setLinkStatus] = useState(''); // '' | 'ok' | 'erro'
  const [customCats, setCustomCats] = useState(() => {
    try { return JSON.parse(localStorage.getItem('customCategorias') || '[]'); } catch { return []; }
  });
  const [novaCat, setNovaCat] = useState('');
  const [allSubcats, setAllSubcats] = useState(() => {
    try { return JSON.parse(localStorage.getItem('customSubcategorias') || '{}'); } catch { return {}; }
  });
  const [novaSubcat, setNovaSubcat] = useState({});
  const [addingSubFor, setAddingSubFor] = useState(null);

  const buscarDadosLink = async (url) => {
    if (!url || !url.startsWith('http')) return;
    setBuscandoLink(true);
    setLinkStatus('');
    try {
      const mlId = parseMlId(url);

      if (mlId) {
        // ── Mercado Livre ──────────────────────────────
        const resp = await fetch(`https://api.mercadolibre.com/items/${mlId}`);
        if (!resp.ok) throw new Error('Produto ML não encontrado');
        const data = await resp.json();

        // Imagens em alta qualidade
        const imgs = (data.pictures || [])
          .map(p => p.secure_url || p.url)
          .filter(Boolean);

        // Descrição
        let descricao = '';
        try {
          const dResp = await fetch(`https://api.mercadolibre.com/items/${mlId}/description`);
          if (dResp.ok) {
            const dData = await dResp.json();
            descricao = (dData.plain_text || '').trim().substring(0, 600);
          }
        } catch {}

        // Dimensões — tenta embalagem primeiro, depois produto
        const attrs = data.attributes || [];
        const alturaRaw  = getMlAttr(attrs, 'PACKAGE_HEIGHT',  'HEIGHT');
        const larguraRaw = getMlAttr(attrs, 'PACKAGE_WIDTH',   'WIDTH');
        const compRaw    = getMlAttr(attrs, 'PACKAGE_DEPTH',   'DEPTH', 'LENGTH');
        const pesoRaw    = getMlAttr(attrs, 'PACKAGE_WEIGHT',  'WEIGHT', 'NET_WEIGHT');

        const altura     = parseCm(alturaRaw);
        const largura    = parseCm(larguraRaw);
        const comprimento = parseCm(compRaw);
        const peso       = parseGramas(pesoRaw);

        // Preço de referência (preço do ML vai para "Preço Web")
        // Meu Preço fica em branco para o usuário definir
        const precoWebML = data.price ? String(data.price) : '';

        // Categorias pelo título
        const cats = detectarCategorias(data.title || '');

        setFormData(prev => ({
          ...prev,
          linkProduto: url,
          titulo:      prev.titulo    || data.title || '',
          precoWeb:    prev.precoWeb  || precoWebML,
          // meuPreco: não preenche — usuário define o próprio preço
          descricao:   prev.descricao || descricao,
          imagens:     prev.imagens.length ? prev.imagens : imgs,
          altura:      prev.altura      || altura,
          largura:     prev.largura     || largura,
          comprimento: prev.comprimento || comprimento,
          peso:        prev.peso        || peso,
          categorias:  prev.categorias.length ? prev.categorias : cats,
        }));
        setLinkStatus('ok');
        setBuscandoLink(false);
        return;
      }

      // ── Fallback genérico: OG tags via proxy ────────
      const proxyResp = await fetch(
        `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`
      );
      if (!proxyResp.ok) throw new Error('Não foi possível acessar o link');
      const html = await proxyResp.text();

      const ogImage       = getOgTag(html, 'image');
      const ogTitle       = getOgTag(html, 'title');
      const ogDescription = getOgTag(html, 'description');

      if (!ogImage && !ogTitle) throw new Error('Nenhuma informação encontrada nesse link');

      setFormData(prev => ({
        ...prev,
        linkProduto: url,
        titulo:    prev.titulo    || ogTitle,
        descricao: prev.descricao || ogDescription,
        imagens:   prev.imagens.length ? prev.imagens : (ogImage ? [ogImage] : []),
      }));
      setLinkStatus('ok');
    } catch (e) {
      setLinkStatus('erro');
      console.error('buscarDadosLink:', e.message);
    }
    setBuscandoLink(false);
  };

  // Auto-busca ao colar um link no campo
  const handleLinkPaste = (e) => {
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    if (pasted && pasted.startsWith('http')) {
      e.preventDefault();
      setFormData(prev => ({ ...prev, linkProduto: pasted }));
      buscarDadosLink(pasted);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const toggleCategoria = (cat) => {
    setFormData(prev => {
      const cats = prev.categorias || [];
      const next = cats.includes(cat) ? cats.filter(c => c !== cat) : [...cats, cat];
      return { ...prev, categorias: next };
    });
  };

  const autoDetectar = () => {
    const cats = detectarCategorias(formData.titulo);
    setFormData(prev => ({ ...prev, categorias: cats }));
  };

  const adicionarCategoria = () => {
    const nome = novaCat.trim();
    if (!nome || customCats.includes(nome) || CATEGORIAS.includes(nome)) return;
    const updated = [...customCats, nome];
    setCustomCats(updated);
    localStorage.setItem('customCategorias', JSON.stringify(updated));
    setNovaCat('');
    setFormData(prev => ({ ...prev, categorias: [...(prev.categorias || []), nome] }));
  };

  const removerCustomCat = (cat) => {
    const updated = customCats.filter(c => c !== cat);
    setCustomCats(updated);
    localStorage.setItem('customCategorias', JSON.stringify(updated));
    setFormData(prev => ({ ...prev, categorias: (prev.categorias || []).filter(c => c !== cat) }));
  };

  const toggleSubcategoria = (sub) => {
    setFormData(prev => {
      const subs = prev.subcategorias || [];
      const next = subs.includes(sub) ? subs.filter(s => s !== sub) : [...subs, sub];
      return { ...prev, subcategorias: next };
    });
  };

  const adicionarSubcategoria = (cat) => {
    const nome = (novaSubcat[cat] || '').trim();
    if (!nome) return;
    const catSubs = allSubcats[cat] || [];
    if (catSubs.includes(nome)) return;
    const updated = { ...allSubcats, [cat]: [...catSubs, nome] };
    setAllSubcats(updated);
    localStorage.setItem('customSubcategorias', JSON.stringify(updated));
    setNovaSubcat(prev => ({ ...prev, [cat]: '' }));
    setFormData(prev => ({ ...prev, subcategorias: [...(prev.subcategorias || []), nome] }));
  };

  const removerSubcategoria = (cat, sub) => {
    const updated = { ...allSubcats, [cat]: (allSubcats[cat] || []).filter(s => s !== sub) };
    setAllSubcats(updated);
    localStorage.setItem('customSubcategorias', JSON.stringify(updated));
    setFormData(prev => ({ ...prev, subcategorias: (prev.subcategorias || []).filter(s => s !== sub) }));
  };

  const uploadParaCloudflare = async (base64) => {
    const wUrl = (localStorage.getItem('workerUrl') || '').replace(/\/$/, '');
    const aToken = localStorage.getItem('authToken') || '';
    if (!wUrl || !aToken) return null;
    const id = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    try {
      const resp = await fetch(`${wUrl}/upload-imagem`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Auth-Token': aToken },
        body: JSON.stringify({ id, imagem: base64 }),
      });
      if (!resp.ok) return null;
      const data = await resp.json();
      return data.url || null;
    } catch {
      return null;
    }
  };

  const loadImages = (files) => {
    Array.from(files).forEach(file => {
      if (!file || !file.type.startsWith('image/')) return;
      setUploadandoCount(prev => prev + 1);
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64 = reader.result;
        const cloudUrl = await uploadParaCloudflare(base64);
        setFormData(prev => ({ ...prev, imagens: [...prev.imagens, cloudUrl || base64] }));
        setUploadandoCount(prev => prev - 1);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleImageUpload = (e) => loadImages(e.target.files);

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    loadImages(e.dataTransfer.files);
  };

  const removeImagem = (idx) => {
    setFormData(prev => ({ ...prev, imagens: prev.imagens.filter((_, i) => i !== idx) }));
  };

  const handleDragStart = (idx) => {
    setDragIdx(idx);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDropReorder = (targetIdx) => {
    if (dragIdx === null || dragIdx === targetIdx) return;
    setFormData(prev => {
      const imgs = [...prev.imagens];
      const [draggedImg] = imgs.splice(dragIdx, 1);
      imgs.splice(targetIdx, 0, draggedImg);
      return { ...prev, imagens: imgs };
    });
    setDragIdx(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.titulo || !formData.meuPreco) {
      alert('Preencha título e seu preço');
      return;
    }
    onAddProduct({
      // Preserva TODOS os campos do produto existente (vendido, _blingId, etc.)
      // Os campos do formulário sobrescrevem somente o que o usuário pode editar
      ...(editProduct || {}),
      linkProduto:  formData.linkProduto,
      titulo:       formData.titulo,
      precoWeb:     formData.precoWeb || '0',
      meuPreco:     formData.meuPreco,
      quantidade:   formData.quantidade,
      altura:       formData.altura,
      largura:      formData.largura,
      comprimento:  formData.comprimento,
      peso:         formData.peso,
      descricao:    formData.descricao,
      imagens:      formData.imagens,
      categorias:   formData.categorias || [],
      subcategorias: formData.subcategorias || [],
    });
    setFormData(EMPTY_FORM);
  };

  return (
    <div className="catalog-form">
      <h2>{editProduct ? 'Editar Produto' : 'Novo Produto'}</h2>

      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <h3>Importar de Link</h3>
          <div className="link-busca-wrap">
            <input
              type="url"
              className="link-input"
              placeholder="Cole o link do Mercado Livre, Shopee, Amazon..."
              value={formData.linkProduto}
              onChange={e => setFormData(prev => ({ ...prev, linkProduto: e.target.value }))}
              onPaste={handleLinkPaste}
            />
            <button
              type="button"
              className={`btn-buscar-link ${linkStatus}`}
              onClick={() => buscarDadosLink(formData.linkProduto)}
              disabled={!formData.linkProduto || buscandoLink}
            >
              {buscandoLink ? '⏳' : linkStatus === 'ok' ? '✅ Importado' : '🔍 Buscar'}
            </button>
          </div>
          {linkStatus === 'erro' && (
            <p className="link-hint link-erro">Não foi possível buscar dados desse link. Preencha manualmente.</p>
          )}
          {linkStatus === 'ok' && (
            <p className="link-hint link-ok">Dados importados! Confira e ajuste o que precisar.</p>
          )}
        </div>

        <div className="form-section">
          <h3>Informações Básicas</h3>

          <div className="form-group">
            <label>Título do Produto *</label>
            <input
              type="text"
              name="titulo"
              value={formData.titulo}
              onChange={handleChange}
              placeholder="Ex: Caixinha de MDF"
              required
            />
          </div>

          <div className="form-row-3">
            <div className="form-group">
              <label>Preço Web (R$)</label>
              <input
                type="number"
                name="precoWeb"
                value={formData.precoWeb}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Meu Preço (R$) *</label>
              <input
                type="number"
                name="meuPreco"
                value={formData.meuPreco}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
                min="0"
                required
              />
            </div>
            <div className="form-group">
              <label>Quantidade em estoque</label>
              <input
                type="number"
                name="quantidade"
                value={formData.quantidade}
                onChange={handleChange}
                placeholder="0"
                min="0"
                step="1"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Descrição</label>
            <textarea
              name="descricao"
              value={formData.descricao}
              onChange={handleChange}
              placeholder="Descreva o produto, material, cores, detalhes..."
              rows="4"
            />
          </div>
        </div>

        <div className="form-section">
          <h3>Categorias</h3>
          <div className="categorias-grid">
            {[...CATEGORIAS, ...customCats].map(cat => (
              <label
                key={cat}
                className={`cat-check ${(formData.categorias || []).includes(cat) ? 'ativo' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={(formData.categorias || []).includes(cat)}
                  onChange={() => toggleCategoria(cat)}
                  style={{ display: 'none' }}
                />
                {cat}
                {customCats.includes(cat) && (
                  <span
                    className="cat-remove"
                    onClick={e => { e.preventDefault(); removerCustomCat(cat); }}
                    title="Remover categoria"
                  >×</span>
                )}
              </label>
            ))}
          </div>
          <div className="nova-cat-wrap">
            <input
              type="text"
              className="nova-cat-input"
              placeholder="Nova categoria..."
              value={novaCat}
              onChange={e => setNovaCat(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); adicionarCategoria(); } }}
            />
            <button type="button" className="btn-add-cat" onClick={adicionarCategoria}>+ Criar</button>
          </div>
          <button type="button" className="btn-auto-cat" onClick={autoDetectar}>
            ✨ Auto-detectar pelo título
          </button>

          {(formData.categorias || []).length > 0 && (
            <div className="subcats-section">
              <div className="subcats-label">Subcategorias</div>
              {(formData.categorias || []).map(cat => {
                const subs = allSubcats[cat] || [];
                return (
                  <div key={cat} className="subcat-cat-group">
                    <div className="subcat-cat-nome">{cat}</div>
                    <div className="categorias-grid">
                      {subs.map(sub => (
                        <label
                          key={sub}
                          className={`cat-check subcat-check ${(formData.subcategorias || []).includes(sub) ? 'ativo' : ''}`}
                        >
                          <input type="checkbox" checked={(formData.subcategorias || []).includes(sub)} onChange={() => toggleSubcategoria(sub)} style={{ display: 'none' }} />
                          {sub}
                          <span className="cat-remove" onClick={e => { e.preventDefault(); removerSubcategoria(cat, sub); }}>×</span>
                        </label>
                      ))}
                    </div>
                    {addingSubFor === cat ? (
                      <div className="nova-cat-wrap" style={{ marginTop: 6 }}>
                        <input
                          type="text"
                          className="nova-cat-input"
                          placeholder={`Nova subcategoria em "${cat}"...`}
                          value={novaSubcat[cat] || ''}
                          onChange={e => setNovaSubcat(prev => ({ ...prev, [cat]: e.target.value }))}
                          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); adicionarSubcategoria(cat); } }}
                          autoFocus
                        />
                        <button type="button" className="btn-add-cat" onClick={() => adicionarSubcategoria(cat)}>+ Criar</button>
                        <button type="button" className="btn-auto-cat" onClick={() => setAddingSubFor(null)} style={{ padding: '7px 10px' }}>✕</button>
                      </div>
                    ) : (
                      <button type="button" className="btn-auto-cat" style={{ marginTop: 4 }} onClick={() => setAddingSubFor(cat)}>
                        + Adicionar subcategoria
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="form-section">
          <h3>Dimensões</h3>
          <div className="form-row-3">
            <div className="form-group">
              <label>Altura (cm)</label>
              <input
                type="number"
                name="altura"
                value={formData.altura}
                onChange={handleChange}
                placeholder="0"
                min="0"
                step="0.1"
              />
            </div>
            <div className="form-group">
              <label>Largura (cm)</label>
              <input
                type="number"
                name="largura"
                value={formData.largura}
                onChange={handleChange}
                placeholder="0"
                min="0"
                step="0.1"
              />
            </div>
            <div className="form-group">
              <label>Comprimento (cm)</label>
              <input
                type="number"
                name="comprimento"
                value={formData.comprimento}
                onChange={handleChange}
                placeholder="0"
                min="0"
                step="0.1"
              />
            </div>
          </div>

          <div className="form-group peso-group">
            <label>Peso (gramas)</label>
            <div className="peso-input-wrap">
              <input
                type="number"
                name="peso"
                value={formData.peso}
                onChange={handleChange}
                placeholder="Ex: 350"
                min="0"
                step="1"
              />
              <span className="peso-unit">g</span>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Imagens do Produto</h3>
          <div
            className="image-drop-zone"
            onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
            onDrop={handleDrop}
          >
            {formData.imagens.length > 0 ? (
              <div className="imagens-grid">
                {formData.imagens.map((img, i) => (
                  <div
                    key={i}
                    className={`imagem-thumb-wrap ${dragIdx === i ? 'dragging' : ''}`}
                    draggable
                    onDragStart={() => handleDragStart(i)}
                    onDragOver={handleDragOver}
                    onDrop={() => handleDropReorder(i)}
                  >
                    <img src={img} alt={`Foto ${i + 1}`} className="imagem-thumb" />
                    <button
                      type="button"
                      className="btn-remove-thumb"
                      onClick={() => removeImagem(i)}
                    >✕</button>
                    {i === 0 && <span className="thumb-principal">Principal</span>}
                  </div>
                ))}
                <label className="imagem-add-btn">
                  + Adicionar
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                </label>
              </div>
            ) : (
              <div className="drop-hint">
                <p>📸 Arraste as imagens aqui ou</p>
                <label className="btn-file">
                  Selecione arquivos
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                </label>
              </div>
            )}
          </div>
          {uploadandoCount > 0 && (
            <p className="imagens-hint" style={{ color: '#667eea', fontWeight: 600 }}>
              ⏳ Enviando {uploadandoCount} foto{uploadandoCount > 1 ? 's' : ''} para o Cloudflare...
            </p>
          )}
          {formData.imagens.length > 0 && uploadandoCount === 0 && (
            <p className="imagens-hint">A primeira imagem é a foto principal do produto.</p>
          )}
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            {editProduct ? '✓ Salvar Alterações' : '✓ Adicionar Produto'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CatalogForm;
